var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{class:_vm.$style.iframe,style:({ height: _vm.config.height, 'min-width': _vm.config.width }),attrs:{"id":_vm.config.id,"src":_vm.config.src},on:{"load":_vm.iframeLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }